import { render, staticRenderFns } from "./ApkDownloadModal.vue?vue&type=template&id=148c99aa&scoped=true"
import script from "./ApkDownloadModal.vue?vue&type=script&lang=js"
export * from "./ApkDownloadModal.vue?vue&type=script&lang=js"
import style0 from "./ApkDownloadModal.vue?vue&type=style&index=0&id=148c99aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148c99aa",
  null
  
)

export default component.exports